import createTheme from '@mui/material/styles/createTheme';
import {
  breakpoints,
  colors,
  typography,
} from '@src/common/styles/valueTokens';

export const muiTheme = createTheme({
  cssVariables: true,
  typography: {
    h1: {
      ...typography.display.large,
    },
    h2: {
      ...typography.display.medium,
    },
    h3: {
      ...typography.display.small,
    },
    h4: {
      ...typography.headline.large,
    },
    h5: {
      ...typography.headline.medium,
    },
    h6: {
      ...typography.headline.small,
    },
    subtitle1: {
      ...typography.title.large,
    },
    subtitle2: {
      ...typography.title.medium,
    },
    body1: { ...typography.body.large },
    body2: { ...typography.body.medium },
    button: {
      ...typography.label.large,
      textTransform: 'none',
    },
    caption: {
      ...typography.body.small,
    },
    allVariants: {
      fontFamily: 'poppins',
      textTransform: 'none',
    },
  },
  palette: {
    primary: {
      main: colors.primary['40'],
    },
    secondary: {
      main: colors.secondary['40'],
    },
    error: {
      main: colors.error['40'],
    },
    warning: {
      main: '#835414',
    },
    success: {
      main: '#1D6B50',
    },
    text: {
      primary: colors.neutral['10'],
      secondary: colors.neutralVariant['30'],
    },
    background: {
      default: colors.neutral['98'],
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: breakpoints.small,
      md: breakpoints.medium,
      lg: breakpoints.large,
      xl: breakpoints.xlarge,
    },
  },
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        input: {
          '&:-webkit-autofill': {
            WebkitBoxShadow: 'unset',
            WebkitTextFillColor: colors.primary['40'],
          },
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          '&.Mui-readOnly': {
            pointerEvents: 'none',
          },
        },
        input: {
          '&.Mui-readOnly': {
            pointerEvents: 'none',
          },
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          '&.Mui-readOnly': {
            pointerEvents: 'none',
          },
        },
        input: {
          '&.Mui-readOnly': {
            pointerEvents: 'none',
          },
        },
      },
    },
  },
});
